import React from 'react';
import { getComponentClasses } from '../../utils/app';

export interface Props {
    variations?: string[];
    href?: string;
    title?: string;
    isDisabled?: boolean;
    onClick?: () => void;
    isSubmit?: boolean;
    children?: React.ReactNode;
    ariaLabel?: string;
    dataTestId?: string;
}

export const IconButton = ({
    variations = [],
    isDisabled = false,
    title,
    href,
    onClick = () => {},
    isSubmit = false,
    children,
    ariaLabel,
    dataTestId = 'icon-button',
}: Props) => {
    // const ButtonType = href ? 'a' : 'button';
    const props = {
        className: getComponentClasses('icon-button', variations),
        'data-disabled': isDisabled,
        type: isSubmit ? 'submit' : 'button',
        title,
        onClick: isDisabled ? () => {} : onClick,
        'aria-label': ariaLabel,
        'data-testid': dataTestId,
    };

    if (href) {
        return (
            <a href={href} {...props}>
                {children}
            </a>
        );
    } else {
        const { type, ...buttonProps } = props;
        const buttonType = type as React.ButtonHTMLAttributes<HTMLButtonElement>['type'];

        return (
            <button type={buttonType} {...buttonProps}>
                {children}
            </button>
        );
    }
};

export default IconButton;
